<template>
  <div class="max-w-xl mx-auto bg-white shadow-md border border-gray-300 p-4">
    <div class="flex justify-between items-center border-b pb-2">
      <div>
        <div class="flex gap-2 items-center">
          <img
            v-if="labelData.company_logo"
            :src="labelData.company_logo"
            class="w-10 h-10 object-cover"
          />
          <img
            v-else
            class="w-10 h-10 object-cover"
            src="@/assets/logo-opsional2.png"
          />
          <h1 class="text-sm font-semibold">
            {{ labelData?.company_name ?? "JASKIPIN EXPRESS INDONESIA" }}
          </h1>
        </div>

        <div v-if="labelData.company_address">
          <p class="text-xs">{{ labelData.company_description }}</p>
          <p class="text-xs">{{ labelData.company_address }}</p>
        </div>
        <div v-else>
          <p class="text-xs">Jasa Kirim Paket Internasional</p>
          <p class="text-xs text-blue-900">www.jaskipin.co.id</p>
        </div>
      </div>
      <div class="text-right">
        <p class="text-sm font-semibold">Shipment Number</p>
        <p class="text-sm font-bold text-gray-700">{{ shipmentNumber }}</p>
      </div>
    </div>

    <!-- From (Sender) & To (Receiver) -->
    <div class="grid grid-cols-2 mt-4 border-b pb-2">
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          From (Sender)
        </h2>
        <p class="text-xs"><strong>Name:</strong> {{ sender.name }}</p>
        <p class="text-xs"><strong>Phone:</strong> {{ sender.phone }}</p>
        <p class="text-xs"><strong>Address:</strong> {{ sender.address }}</p>
      </div>
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          Consignment Note
        </h2>
        <p class="text-xs"><strong>Airwaybill:</strong> {{ airwaybill }}</p>
        <div class="border p-2 flex justify-center">
          <p class="font-mono text-lg">{{ airwaybill }}</p>
        </div>
      </div>
    </div>

    <!-- Consignment Note -->
    <div class="grid grid-cols-2 mt-4 border-b pb-2">
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          To (Receiver)
        </h2>
        <p class="text-xs"><strong>Name:</strong> {{ receiver.name }}</p>
        <p class="text-xs"><strong>Phone:</strong> {{ receiver.phone }}</p>
        <p class="text-xs">
          <strong>Delivery Address:</strong> {{ receiver.address }}
        </p>
        <p class="text-xs">
          <strong>Post Code:</strong> {{ receiver.postCode }}
        </p>
        <p class="text-xs"><strong>Country:</strong> {{ receiver.country }}</p>
      </div>
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          Authorization
        </h2>
        <ul class="list-decimal pl-4 text-xs">
          <li v-for="(rule, index) in authorization" :key="index">
            {{ rule }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Authorization -->

    <!-- Received By Courier & Signature -->
    <div class="grid grid-cols-3 mt-4 border-t pt-2">
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          Received By Courier
        </h2>
        <p class="text-xs"><strong>Name:</strong> {{ courier.name }}</p>
        <p class="text-xs"><strong>Date:</strong> {{ courier.date }}</p>
        <p class="text-xs">
          <strong>Signature:</strong> {{ courier.signature }}
        </p>
      </div>
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          Signature (Sender)
        </h2>
        <p class="text-xs"><strong>Name:</strong> {{ sender.name }}</p>
      </div>
      <div>
        <h2 class="font-semibold bg-blue-900 text-white text-xs px-2 py-1">
          Shipment Information
        </h2>
        <table
          class="w-full text-xs border-collapse border border-gray-300 mt-2"
        >
          <thead>
            <tr class="bg-gray-200">
              <th class="border text-xs">No</th>
              <th class="border text-xs">Description of Goods</th>
              <th class="border text-xs">Custom Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in shipmentInfo" :key="index">
              <td class="border text-xs text-center">{{ index + 1 }}</td>
              <td class="border text-xs">{{ item.description }}</td>
              <td class="border text-xs text-center">{{ item.customValue }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Shipment Information -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      shipmentNumber: "JEX0000130310",
      sender: {
        name: "Debby (Packaging Solution Indonesia)",
        phone: "+6285857343955",
        address: "Jl. Raya Pilang KM 8F Sidoarjo",
      },
      receiver: {
        name: "Yi Chun Lin (Emily)",
        phone: "886905267895",
        address:
          "Mo Chyi Enterprise Co., Ltd No. 188, Ln 141, Sec. 4, Zhangxin Rd., Hemei Township, Changhua County 508, Taiwan",
        postCode: "508018",
        country: "Taiwan",
      },
      airwaybill: "JEX0000130310",
      authorization: [
        "Jika barang di tolak oleh Custom Negara setempat maka bukan tanggungjawab",
        "Ongkos Kirim tidak termasuk biaya import/Duty Tax jika muncul di negara tujuan",
        "Customer Wajib Memberikan informasi detail barang yang di kirim (harga & jumlah barang)",
      ],
      courier: {
        name: "Karia Global Express",
        date: "February 3, 2025",
        signature: "+62 896-7764-6567",
      },
      shipmentInfo: [{ description: "Tutup Toples", customValue: "IDRO" }],
    };
  },
  //   check session
  computed: {
    labelData() {
      let profile = JSON.parse(
        localStorage.getItem("data-label-jaskipin-agen")
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped></style>
